export default __webpack_public_path__ + "static/media/hourglass.b6a29fb7.svg";